import type { NavigateFunction } from 'react-router-dom';
import { encodeUrl } from './encodeUrl';

/** Só existe quando o usuário clicou em "criar conta" a partir do login do fluxo público de `/agendamento`. */
export const SCHEDULING_REGISTRATION_PENDING_KEY =
	'scheduling_registration_pending';

/**
 * Remove rascunho de agendamento público (evita cadastro em `/cadastro` herdar LS antigo).
 */
export function clearPublicSchedulingDraftFromLocalStorage(): void {
	try {
		localStorage.removeItem('isSchedulingFlow');
		localStorage.removeItem('session_data');
		localStorage.removeItem(SCHEDULING_REGISTRATION_PENDING_KEY);
		localStorage.removeItem('scheduling_pay_after_auth');
	} catch {
		// ignore
	}
}

/**
 * Mesma regra de `session.service` (Role.User): ≥10 min de antecedência.
 * Margem extra para skew de relógio cliente/servidor.
 */
const MIN_USER_LEAD_MS = 10 * 60 * 1000 + 15_000;

export function schedulingSelectedDateStillBookable(
	selectedDate: unknown,
): boolean {
	if (typeof selectedDate !== 'string' || !selectedDate.trim()) return false;
	const t = new Date(selectedDate).getTime();
	if (Number.isNaN(t)) return false;
	return t > Date.now() + MIN_USER_LEAD_MS;
}

/** Mensagens do back quando o rascunho em `session_data` ficou inválido. */
export function isStaleSchedulingSessionError(message: string): boolean {
	const m = message.toLowerCase();
	return (
		m.includes('passado') ||
		m.includes('antecedência') ||
		m.includes('antecedencia')
	);
}

export function buildAgendamentoResumePath(
	draft: Record<string, unknown>,
): string {
	const pid = draft.professional_id;
	if (typeof pid === 'string' && pid.length > 0) {
		return `/agendamento?d=${encodeUrl({ s: 2, p: pid })}`;
	}
	return '/agendamento';
}

/**
 * Limpa rascunho do fluxo público e volta ao `/agendamento` no passo de data/hora
 * com o mesmo profissional quando possível (não altera o fluxo normal de quem ainda tem horário válido).
 */
export function navigateAfterExpiredSchedulingDraft(
	navigate: NavigateFunction,
	draft: Record<string, unknown>,
	opts?: { replace?: boolean; removePAuth?: boolean },
): void {
	try {
		localStorage.removeItem('isSchedulingFlow');
		localStorage.removeItem('session_data');
		localStorage.removeItem(SCHEDULING_REGISTRATION_PENDING_KEY);
		if (opts?.removePAuth) localStorage.removeItem('pAuth');
	} catch {
		// ignore
	}
	navigate(buildAgendamentoResumePath(draft), {
		replace: opts?.replace ?? true,
	});
}
